var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('img',{attrs:{"src":_vm.requireImg()}})]),_c('v-flex',[_c('p',[_vm._v("\n        "+_vm._s(_vm.$t('gif.TEXT'))+"\n      ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }